export function scrollIntoPage(id) {
  try {
    document.getElementById(`page_${id}`).scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  } catch (error) {
    console.error("Scroll into page failed : ", error);
  }
}
